<planone-sidebar-container [showMobileBottomBar]="(showMobileBottomBar$ | async) ?? false">
  <ng-template #teaser>
    @if (insightsId$ | async; as fairId) {
    <bau365-section-header
      [givenName]="givenName"
      [familyName]="familyName"
      [size]="size$ | async"
      [searchSuggestions]="searchSuggestions$ | async"
      [quicklinks]="quicklinks$ | async"
      (searchTermChange)="onSearchTermChanged($event)"
      (searchTermSubmit)="onSearchTermSubmitted()"
      (clickQuicklink)="onQuicklinkClick(fairId, $event)"
      [fairId]="insightsId$ | async"></bau365-section-header>
    }
  </ng-template>
  <ng-template #sidebar>
    <ng-container *ngTemplateOutlet="channels"></ng-container>
  </ng-template>
  <ng-template #modalContent>
    <ng-container *ngTemplateOutlet="channels"></ng-container>
  </ng-template>
  <ng-template #modalTitle>
    <div class="bottom-sheet-title mat-headline-3" i18n="@@featureNewsfeed-channelsTitle">Kanäle</div>
  </ng-template>
  <ng-template #section>
    <ng-container *ngTemplateOutlet="results"></ng-container>
  </ng-template>
</planone-sidebar-container>

<ng-template #channels>
  <bau365-section-channels
    [source]="source$ | async"
    [sponsoredChannels]="sponsoredChannels$ | async"
    [subscribedChannels]="subscribedChannels$ | async"
    [showHistoryChannel]="isHistoryChannelAvailable$ | async"
    [fairId]="insightsId$ | async"
    (selectForMe)="onSelectForMe()"
    (selectLastViewed)="onSelectLastViewed()"
    (selectChannel)="onSelectChannel($event)"></bau365-section-channels>
</ng-template>
<ng-template #results>
  @if (resultsLoaded$ | async) { @if (((results$ | async) ?? []).length > 0) {
  <bau365-section-result-list [results]="results$ | async" [insightsId]="insightsId$ | async" [size]="size$ | async">
  </bau365-section-result-list>
  @if ((isLoadingMoreResults$ | async) === false) { @if (moreResultsAvailable$ | async) {
  <bau365-section-load-more
    [count]="resultsCount$ | async"
    [loaded]="resultsLoaded$ | async"
    (loadMore)="onLoadMoreResults()">
  </bau365-section-load-more>
  } } @else {
  <bau365-section-loading></bau365-section-loading>
  } } @else {
  <bau365-section-no-results></bau365-section-no-results>
  } } @else {
  <bau365-section-loading></bau365-section-loading>
  }
</ng-template>
